import { CallBackFormData } from 'components';
import { getApiRetryInstance } from './getApiInstance';

export interface OpeningHoursProps {
	close: string;
	open: string;
}
export type RequestState = 'success' | 'error' | 'info';
const alreadyRegisteredNumber = '116';
const api = getApiRetryInstance();

export const getOpeningHours = async (days: number): Promise<OpeningHoursProps[]> => {
	const startTime = new Date();
	if (startTime.getHours() > 8) {
		// adjustDaylightSaving for startTime
		const adjustDaylightSaving = startTime.getTimezoneOffset() === -120 ? 1 : 0;
		startTime.setHours(startTime.getHours() + 1 + adjustDaylightSaving);

		startTime.setMinutes(startTime.getMinutes() + 30);
	}

	try {
		const getOpeningHoursApi = await api.post(`/api/v1/callmeback/OpeningHours`, {
			from: startTime.toISOString(),
			days: days.toString(),
		});
		const data = getOpeningHoursApi.data;
		return adjustForDaylightSaving(data);
	} catch (error) {
		throw new Error(error);
	}
};

const adjustForDaylightSaving = (data: OpeningHoursProps[]) => {
	const adjustDaylightData: OpeningHoursProps[] = [];
	let open: Date;
	let close: Date;
	data.forEach((timeSlots: OpeningHoursProps) => {
		open = new Date(timeSlots.open);
		if (open.getTimezoneOffset() === -120) {
			// adjust for daylight saving - sommertid
			open.setHours(open.getHours() - 1);
			close = new Date(timeSlots.close);
			close.setHours(close.getHours() - 1);

			adjustDaylightData.push({
				open: open.toISOString(),
				close: close.toISOString(),
			});
		} else {
			adjustDaylightData.push(timeSlots);
		}
	});
	return adjustDaylightData;
};

export const registerCallBack = async (
	formData: CallBackFormData,
	selectedDate: OpeningHoursProps,
): Promise<RequestState> => {
	try {
		// We generate the time options based on the selectedDate.Open.
		// Then the selectedTimeIndex will correlate with added hours for each of the options based on the opening time on the selected date.

		const startTime = new Date(selectedDate.open);

		startTime.setHours(Number.parseInt(formData.selectedTimeIndex));

		const registerCallApi = await api.post(
			`/api/v1/callmeback/BookMeeting`,
			// JSON.stringify({
			{
				customerNumber: formData.customerNumber,
				customerName: formData.name,
				dateTimeStart: startTime.toISOString(),
				customerPhoneNumber: formData.phoneNumber,
				bankAdvisorEmail: formData.bankAdvisorEmail,
				callSubject: formData.selectedCallSubject,
				bankAndBranch: formData.selectedBank,
			},
			// }),
		);
		const data = registerCallApi.data;
		if (data?.resultCode === 'error') return 'error';
		if (data?.resultCode == alreadyRegisteredNumber) return 'info';
		return 'success';
	} catch (error) {
		throw new Error(error);
	}
};
